module.exports = __webpack_public_path__ + "static/partner-cta-5a414b0a00ece4e3f0a6f966b271774b.png";